import actions from './actions'

const initialState = {
  teamCollaboratorsList: [],
  teamCollaboratorsListTotal: 0,
  teamCollaboratorsActive: [],
  teamLoggedInCollaborator: [],
  teamCollaboratorSearchText: '',
  areTeamMembersLoading: true,
}

export default function teamsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
